export const SamplePrefixRegex = /^[a-zA-Z-_0-9=.]+$/
export const SampleTitleRegex = /^[a-zA-Z-_0-9=.]+$/
export const KaryotypeRegex = /^[a-zA-Z-_0-9=.\s,()/]+$/